<template>
  <PulseButton v-bind="$attrs" variant="secondary">
    <template #icon-left>
      <PulseLinePen class="h-3 w-3 fill-path-current" />
    </template>

    Edit
  </PulseButton>
</template>
